import { Component, EventEmitter, Input, Output } from '@angular/core'
import { GuardianInvite } from '@se-po/shared-data-access-models'

@Component({
  selector: 'se-po-invite-review',
  templateUrl: './invite-review.component.html',
  styleUrls: ['./invite-review.component.scss'],
  standalone: false,
})
export class InviteReviewComponent {
  @Input() public guardianEmails: string[] = []
  @Input() public invites: GuardianInvite[]
  @Output() public back: EventEmitter<void> = new EventEmitter()
  // eslint-disable-next-line @angular-eslint/no-output-native
  @Output() public cancel: EventEmitter<GuardianInvite> = new EventEmitter()
  @Output() public continue: EventEmitter<void> = new EventEmitter()

  public translationKey = 'SE_PO_SE_PERSONA_PICKER_FEATURE_ADD_GUARDIAN_MODAL.'

  public get canInviteGuardians(): boolean {
    // can have up to 10 guardians per child, plus the account owner.
    return (this.invites?.length || 0) + this.guardianEmails.length < 11
  }

  public onCancel(invite: GuardianInvite): void {
    this.cancel.emit(invite)
  }

  public onContinue(): void {
    this.continue.emit()
  }

  public onInvite(): void {
    this.back.emit()
  }
}
